import * as angular from 'angular';

const MonetateConstants = {
    MONETATE_INFO: {
        SETPAGETYPE: 'setPageType',
        CUSTOMVARS: 'setCustomVariables',
        TRACKDATA: 'trackData'
    },
    PREFIX:{
        DATALAYER_GENERAL: 'dt_g_',
        DATALAYER_ECOMMERCE: 'dt_e_',
        DIGITAL_DATA: 'dd_'
    },
    FUNCTIONS: {
        ADDCARTROWS: 'addCartRows',
        ADDPURCHASEROWS: 'addPurchaseRows',
        ADDPRODUCTDETAILS: 'addProductDetails'
    },
    TRACK_PLACE: {
        CART: 'cart',
        PURCHASE: 'purchase'
    },
    CATALOG_PRODUCTS_ID: {
        ANCILLARIES: {
            SEAT: {
                DELANTERO: 'ASIENTO-DELANTERO',
                SALIDA_EMERGENCIA: 'ASIENTO-SALIDAEMERG',
                XL: 'ASIENTO-XL',
                NORMAL: 'ASIENTO-NORMAL',
                BEBE: 'ASIENTO-CONBEBE',
                MOVILIDAD_REDUCIDA: 'ASIENTO-MOVREDUCIDA',
                PROMO: 'ASIENTO-PROMO'
            },
            BAGGAGE: {
                EQUIPAJE_EXTRA: 'MALETAS-EQUIPAJEEXTRA',
                EQUIPAJE_EXTRA_15: 'MALETAS-EQUIPAJEEXTRA-15',
                EQUIPAJE_EXTRA_23: 'MALETAS-EQUIPAJEEXTRA-23',
                EQUIPAJE_EXTRA_32: 'MALETAS-EQUIPAJEEXTRA-32',
                EQUIPAJE_ESPECIAL: 'MALETAS-EQUIPAJEESPECIAL',
                EQUIPAJE_ESPECIAL_BIKE: 'MALETAS-EQUIPAJEESPECIAL-BIKE',
                EQUIPAJE_ESPECIAL_SKIS: 'MALETAS-EQUIPAJEESPECIAL-SKIS',
                EQUIPAJE_ESPECIAL_GOLF: 'MALETAS-EQUIPAJEESPECIAL-GOLF'
            },
            INSURANCE: {
                SEGURO_ANULACION: 'SEGURO-ANULACION',
                SEGURO_ASISTENCIA: 'SEGURO-ASISTENCIA'
            },
            FLEXIBILIZATION: {
                CAMBIO: 'FLEXIBILIDAD-CAMBIO',
                REEMBOLSO: 'FLEXIBILIDAD-REEMBOLSO',
                PACK: 'FLEXIBILIDAD-PACK'
            },
            PRIORIDAD: 'PRIORIDAD'

        },
        FLIGHT_PASSENGERS: {
            MENOR: 'V-MENOR',
            BEBE: 'V-INFANT',
            RESIDENTE_BALEARES: 'V-RES-BALE',
            RESIDENTE_CANARIAS: 'V-RES-CANA',
            FAM_NUMEROSA_GENERAL: 'V-FAMNUM-GRAL',
            FAM_NUMEROSA_ESPECIAL: 'V-FAMNUM-ESP'
        },
        CABIN_TYPE: {
            TURISTA: 'V-CABINA-TURISTA',
            PREMIUM: 'V-CABINA-PREMIUM',
            BUSINESS: 'V-CABINA-BUSINESS'
        },
        FLIGHT_FARE: {
            GENERICAS: {
                MAS_ECONOMICA: 'V-TARIF-ECONOMICA',
                FLEXIBLES: 'V-TARIF-FLEXIBLES',
                CABINAS_PREMIUM: 'V-TARIF-CABINASPREMIUM'
            },
            TURISTA: {
                BASICA: 'V-TARIF-TURIST-BASICA',
                BASICA_PLUS: 'V-TARIF-TURIST-BASICAPLUS',
                OPTIMA: 'V-TARIF-TURIST-OPTIMA',
                OPTIMA_FLEX: 'V-TARIF-TURIST-OPTIMAFLEX',
                CONFORT: 'V-TARIF-TURIST-CONFORT',
                FLEXIBLE: 'V-TARIF-TURIST-FLEXIBLE'

            },
            PREMIUM: {
                FLEX: 'V-TARIF-PREMIUM-FLEX',
                OPTIMA_FLEX: 'V-TARIF-PREMIUM-OPTIMAFLEX',
                PROMO: 'V-TARIF-PREMIUM-PROM',
                OPTIMA: 'V-TARIF-PREMIUM-OPTIMA',
                PROM_FLEX: 'V-TARIF-PREMIUM-PROMFLEX'

            },
            BUSINESS: {
                FLEX: 'V-TARIF-BUSINESS-FLEX',
                OPTIMA_FLEX: 'V-TARIF-BUSINESS-OPTIMAFLEX',
                PROMO: 'V-TARIF-BUSINESS-PROM',
                PROM_FLEX: 'V-TARIF-BUSINESS-PROMFLEX',
                OPTIMA: 'V-TARIF-BUSINESS-OPTIMA'
            }
        },
        FLIGHT_DESTINATION: {
            ESPANA: 'VD-ESPANA',
            EUROPA: 'VD-EUROPA',
            LATAM: 'VD-LATAM',
            AMERICANORTE: 'VD-AMERICANORTE',
            ASIA: 'VD-ASIA',
            AFRICA: 'VD-AFRICA'
        },
        TRIP_TYPE: {
            VACACIONES_FIN_DE_SEMANA: 'V-VAC-FINDESEMANA',
            VACACIONES_INVIERNO: 'V-VAC-INVIERNO',
            VACACIONES_VERANO: 'V-VAC-VERANO',
            VACACIONES_NEGOCIO: 'V-NEGOCIOS'
        }
    },
    CONTINENTS_AND_COUNTRIES: {
        AMERICA: 'América',
        US: 'US',
        CANADA: 'CA',
        LATAM: 'LATAM'
    },
    DEFAULT_VALUES: {
        ZERO: '0',
        ONE: '1'
    },
    CABIN_DESCRIPTION:{
        ECONOMY: 'Economy',
        PREMIUM_ECONOMY: 'Premium Economy',
        BUSINESS: 'Business'
    }
};
angular.module('ib-monetate-module', []).constant('MonetateConstants', MonetateConstants);
export { MonetateConstants };
export type MonetateConstantsType = typeof  MonetateConstants;

